export interface DBFolder {
  id: string;
  project_id: string;
  name: string;
  icon: string;
  color: string;
  sort_order: number;
  created_by: string | null;
  created_at: string;
}

export interface DBFile {
  id: string;
  project_id: string;
  folder_id: string | null;
  file_name: string;
  file_url: string;
  storage_bucket?: string | null;
  storage_path?: string | null;
  file_size: string | number | null;
  file_type: string | null;
  note: string | null;
  uploaded_by: string | null;
  created_at: string;
  is_visible?: boolean;
  is_client_visible?: boolean | null;
  is_subcontractor_visible?: boolean | null;
  photo_type?: string | null;
  is_deleted?: boolean;
  deleted_at?: string | null;
}

export const fileTypeIcon: Record<string, string> = {
  pdf: 'ri-file-pdf-line', image: 'ri-image-line', jpg: 'ri-image-line', jpeg: 'ri-image-line', png: 'ri-image-line', gif: 'ri-image-line', webp: 'ri-image-line', doc: 'ri-file-word-line', docx: 'ri-file-word-line', xls: 'ri-file-excel-line', xlsx: 'ri-file-excel-line', txt: 'ri-file-text-line', zip: 'ri-folder-zip-line', other: 'ri-file-line',
};

export const fileTypeColor: Record<string, string> = {
  pdf: '#EF4444', image: '#059669', jpg: '#059669', jpeg: '#059669', png: '#059669', gif: '#059669', webp: '#059669', doc: '#3B82F6', docx: '#3B82F6', xls: '#059669', xlsx: '#059669', txt: '#6B7280', zip: '#F59E0B', other: '#9CA3AF',
};

export function getFileExt(name: string): string {
  return name.split('.').pop()?.toLowerCase() || 'other';
}
export function isImageType(ext: string): boolean {
  return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'image'].includes(ext);
}
export function formatBytes(bytes: string | number | null): string {
  if (bytes === null || bytes === undefined || bytes === '') return '—';
  const num = typeof bytes === 'string' ? parseFloat(bytes) : bytes;
  if (Number.isNaN(num) || num === 0) return '—';
  if (num < 1024) return `${num} B`;
  if (num < 1024 * 1024) return `${(num / 1024).toFixed(0)} KB`;
  return `${(num / (1024 * 1024)).toFixed(1)} MB`;
}
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}
export function resolvePhotoUrl(file: DBFile): string {
  return file.file_url || '';
}
